export default __webpack_public_path__ + "static/media/play.5ca79658.svg";